@let testIdVal = testId();
@let upgradeVal = upgrade();
@let minimizedVal = minimized();

@let tooltipAttached = !isChild() || !!upgradeVal;

@let template = tooltipAttached ? withTooltip : withoutTooltip;

<ng-container [ngTemplateOutlet]="template" />

<ng-template #withTooltip>
  @let tooltipEnabled = minimizedVal || !!upgradeVal;
  @let tooltipMessage = upgradeVal && !minimizedVal ? upgradeVal?.label : label();

  <a
    [attr.data-cy]="testIdVal"
    [href]="href()"
    (click)="onAnchorClick($event)"
    [rtTooltip]="tooltipMessage"
    [rtTooltipPosition]="'right'"
    [rtTooltipEnabled]="tooltipEnabled"
    [rtTooltipHideDelay]="50"
    [rtTooltipShowDelay]="50"
    [rtTooltipHasNoArrow]="true"
  >
    <ng-container [ngTemplateOutlet]="navLabelItem" />
  </a>
</ng-template>

<ng-template #withoutTooltip>
  <a [attr.data-cy]="testIdVal" [href]="href()" (click)="onAnchorClick($event)">
    <ng-container [ngTemplateOutlet]="navLabelItem" />
  </a>
</ng-template>

<ng-template #navLabelItem>
  <tlc-navigation-label
    [minimized]="minimized()"
    [label]="label()"
    [icon]="icon()"
    [iconSvg]="iconSvg()"
    [badges]="badges()"
    [showUpgradeIcon]="!!upgradeVal"
  />
</ng-template>
